import confetti from "canvas-confetti";
export const emojiEffect = () => {
  const scalar = 2;
  const unicorn = confetti.shapeFromText({ text: "🎈", scalar });

  const defaults = {
    spread: 360,
    ticks: 60,
    gravity: 0,
    decay: 0.96,
    startVelocity: 10,
    shapes: [unicorn],
    scalar,
  };

  const shoot = () => {
    confetti({
      ...defaults,
      particleCount: 15,
      startVelocity: 10,
    });

    confetti({
      ...defaults,
      particleCount: 15,
      flat: true,
      startVelocity: 20,
    });

    confetti({
      ...defaults,
      particleCount: 25,
      scalar: scalar / 2,
      shapes: ["circle"],
      startVelocity: 30,
    });
  };

  setTimeout(shoot, 0);
  setTimeout(shoot, 300);
  setTimeout(shoot, 400);
};
